/**
 * Gemeinsamer Abruf von GET /api/ui/state (Performance, 25.09.2026).
 *
 * Bis zu sechs Komponenten (Job-Anzeige, Telegram-Widget, Staging-Anzeigen)
 * fragten ui/state unabhaengig voneinander ab — beim Seitenaufbau des
 * Communication Centers 4x gleichzeitig. Hier teilen sich gleichzeitige
 * Aufrufe EINE laufende Anfrage, und ein Ergebnis bleibt kurz (3 s) gueltig.
 * Die Polling-Intervalle der Komponenten bleiben unveraendert.
 *
 * Rueckgabe hat bewusst die Form eines fetch-Response ({ ok, status, json() }),
 * damit die Aufrufer nur die Zeile mit dem fetch tauschen muessen.
 */

const TTL_MS = 3000;
let inflight = null;
let cached = null; // { at, result }

function getToken() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem('auth_token') || localStorage.getItem('token') || null;
  } catch {
    return null;
  }
}

function wrap(result) {
  return {
    ok: result.ok,
    status: result.status,
    json: async () => result.json,
  };
}

export async function fetchUiState({ maxAgeMs = TTL_MS } = {}) {
  if (cached && Date.now() - cached.at < maxAgeMs) return wrap(cached.result);

  if (!inflight) {
    inflight = (async () => {
      const token = getToken();
      const res = await fetch('/api/ui/state', {
        cache: 'no-store',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        signal: AbortSignal.timeout(8000),
      });
      const json = res.ok ? await res.json().catch(() => null) : null;
      const result = { ok: res.ok, status: res.status, json };
      if (res.ok) cached = { at: Date.now(), result };
      return result;
    })().finally(() => {
      inflight = null;
    });
  }

  return wrap(await inflight);
}
